export default __webpack_public_path__ + "static/media/linkedinLogo.31e371d0.svg";